var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconCode = function SvgMiconCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "m31 16-7 7-1.41-1.41L28.17 16l-5.58-5.59L24 9zM1 16l7-7 1.41 1.41L3.83 16l5.58 5.59L8 23zM17.64 6.002l-5.221 19.482 1.932.518 5.22-19.483z"
  })));
};
export default SvgMiconCode;